<template>
  <div v-if="!webviewStore.isActive" class="relative">
    <div
      class="relative w-full h-[50px] desktop:h-[60px] flex items-center justify-center font-secondary"
    >
      <div
        v-if="showBackButton"
        class="absolute left-3 flex items-center cursor-pointer"
        @click="handleBackClick"
      >
        <ChevronLeftIcon class="size-[25px] shrink-0 text-gray-800" />
        <div class="font-secondary">Back</div>
      </div>

      <a href="/">
        <img
          v-if="origin && origin.id !== 'Dacr'"
          :src="origin.logo.black.url"
          class="h-9 pr-[15px]"
        />
        <DacrWordLogo v-else class="h-[26px] desktop:h-[30px]" />
      </a>

      <div
        v-if="$slots.action"
        class="absolute right-5 top-1/2 -translate-y-1/2 flex items-center"
      >
        <slot name="action" />
      </div>

      <div
        v-if="props.showCta"
        class="hidden tablet-v:flex absolute right-[18px] items-center"
      >
        <a
          href="/download"
          class="hidden font-primary font-medium text-[14px] leading-[25px] text-gray-800 items-center gap-[8px] rounded-[6px] pt-[2px] pr-[10px] pb-[3px] pl-[3px] hover:bg-gray-200/25 transition-colors duration-250 mr-[10px] cursor-pointer tablet-v:flex"
          target="_blank"
        >
          <div
            class="w-6 h-6 shrink-0 flex items-center justify-center rounded-[7px] border border-gray-400/25 bg-white"
          >
            <DacrMarkIcon class="size-[17px] shrink-0" />
          </div>
          <div class="font-primary">Get app</div>
        </a>

        <Button variant="primary" @click="handleCreateAccountClick">
          Create account
        </Button>
      </div>
    </div>

    <div
      v-if="origin && origin.id !== 'Dacr'"
      class="font-secondary text-[14px] leading-[18px] text-gray-800 font-medium flex items-center gap-x-1 w-full justify-center"
    >
      Powered by

      <DacrWordLogo class="h-[15px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { Button } from '@dacr/library'
import { ChevronLeftIcon, DacrMarkIcon } from '@dacr/icons'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import { useOriginStore } from '@/shared/stores/origin'
import { useWebviewStore } from '@/shared/stores/webview'
import { backOrFallback } from '@/shared/utils/navigation'

const props = defineProps<{
  showCta?: boolean
}>()

const route = useRoute()
const router = useRouter()
const originStore = useOriginStore()
const webviewStore = useWebviewStore()

const origin = computed(() => originStore.userOrigin)

const showBackButton = computed(() => {
  return route.name === 'ForgotPassword'
})

const handleBackClick = () => {
  backOrFallback(router, '/login')
}

const handleCreateAccountClick = () => {
  if (route.query.email) {
    router.push(`/register?email=${route.query.email}`)
  } else {
    router.push('/register')
  }
}
</script>
